import Icon from '../../components/Icon.vue';
Icon.register({
  'brands/figma': {
    width: 384,
    height: 512,
    paths: [{
      d: 'M277 170.7h-85.4v256c0 47.1-38.3 85.3-85.4 85.3-47.1 0-85.3-38.2-85.3-85.3 0-47.1 38.2-85.4 85.3-85.4h0.1c-47.1 0-85.3-38.2-85.3-85.3 0-47.1 38.2-85.4 85.3-85.4-47.1 0-85.3-38.2-85.3-85.3s38.2-85.3 85.3-85.3h170.7c47.1 0 85.3 38.2 85.3 85.3 0 47.1-38.2 85.4-85.3 85.4zM277 170.7c47.1 0 85.3 38.2 85.3 85.3 0 47.1-38.2 85.3-85.3 85.3s-85.3-38.2-85.3-85.3 38.2-85.3 85.3-85.3z'
    }]
  }
});